module.exports = __webpack_public_path__ + "static/img/1.6d2a926.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/1.png
// module id = InzO
// module chunks = 0